var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7262 7.15548L11.7301 12.1582L2.96437 7.28533V6.55818C2.96437 5.69882 3.68749 5 4.5822 5H19.1133C20.0056 5 20.7311 5.69646 20.7311 6.55818V7.15548H20.7262ZM20.7262 8.95211V17.4418C20.7262 18.3012 20.0031 19 19.1084 19H4.57975C3.68749 19 2.96191 18.3035 2.96191 17.4418V9.08196L11.3281 13.7329C11.6149 13.8934 11.9605 13.8627 12.2105 13.6857C12.2228 13.6809 12.2326 13.6739 12.2449 13.6691L20.7262 8.95211Z",
    fill: "#257FFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.aae1618a.svg";
export { ForwardRef as ReactComponent };